import type { APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type FundingStage = APIResponse<'/api/v4/funding-stages'>[number];

export const fetchFundingStages = () =>
  get<FundingStage[]>('/v4/funding-stages');
